// extracted by mini-css-extract-plugin
export default {"form":"form_styles_form__5C8Pp","form__container":"form_styles_form__container__tF6ij","form__input":"form_styles_form__input__AlkaV","error":"form_styles_error__dP-2i"};